import React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from "react-router-dom";
import "./Page.css";

const Container = styled.div(
    {
        width: '100%',
        marginTop: '64px',
        // margin: 'auto',
        padding: '0px',
        paddingBottom: '6px',
    }
)

const Img = styled.img(
    {
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        // boxShadow: '3px 3px 3px 3px lightgray'
    }
)

const DocPage = (props) => {
    
    const url = `${process.env.REACT_APP_API}/images/${props.documentId}/${props.page -1}/${props.openId}`;
    return (
        <Container 
    //     className={
    //     props.classDiv != "" ? "no-visual-search d-flex justify-content-center " + props.classDiv : "no-visual-search d-flex justify-content-center"
    //   }
         className="no-visual-search d-flex justify-content-center"
         >
             <Img id='page' src={url} className={props.class} alt="Page Not Found" align="left" />
            {/* className={props.class} */}
        </Container>
    )
};
  
export default DocPage;
